import React, { useState } from 'react';
import Navbar from '../../commonComponents/Navbar';
import HomepageBanner from '../../Componentsss/Homepage/HomepageBanner/HomepageBanner';
import Welcome from '../../Componentsss/Homepage/Welcome/Welcome';
import GlobalTravel from '../../Componentsss/Homepage/GlobalTravel/GlobalTravel';
import TravelSolution from '../../Componentsss/Homepage/TravelSolution/TravelSolution';
import Video from '../../Componentsss/Homepage/Video/Video';
import CorporateTraveler from '../../Componentsss/Homepage/CorporateTraveler/CorporateTraveler';
import BusinessTravel from '../../Componentsss/Homepage/BusinessTravel/BusinessTravel';
import CorporateTravel from '../../Componentsss/Homepage/CorporateTravel/CorporateTravel';
import NeedHelp from '../../Componentsss/Homepage/NeedHelp/NeedHelp';
import Footer from '../../commonComponents/Footer';
import RegionalSection from '../../Componentsss/Homepage/RegionalSection/RegionalSection';

const HomePage = () => {
    // Wait until the banner signals that the first image has loaded.
    const [bannerLoaded, setBannerLoaded] = useState(false);

    
    return (
        <>
            {bannerLoaded && <Navbar />}
            <HomepageBanner onLoad={() => setBannerLoaded(true)} />
            {bannerLoaded && (
                <>
                    <Welcome />
                    <GlobalTravel />
                    <TravelSolution />
                    <Video />
                    <RegionalSection />
                    <CorporateTraveler />
                    <BusinessTravel />
                    <CorporateTravel />
                    <NeedHelp />
                    <Footer />
                </>
            )}
        </>
    );
};

export default HomePage;
